import { post } from "@utils/httpUtil";
export function findMessageList(data, config) {
  return post(`/c/pc/common/message/findMessageList`, data, config);
}
export function cleanNotReadMessage(data, config) {
  return post(`/c/pc/common/message/cleanNotReadMessage`, data, config);
}